module.exports = __webpack_public_path__ + "static/media/awake@2x.0e2d428c.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_31/imgs/awake@2x.png
// module id = 912
// module chunks = 0